import { requestLocationChange } from '../actions';

const apiErrorInterceptor = store => next => action => {
  if (!action.error) return next(action);

  // Redirect to login page if unauthorized
  if (action.payload.status === 401) {
    store.dispatch(requestLocationChange('login'));
  }

  return next(action);
};

export default apiErrorInterceptor;



/** WEBPACK FOOTER **
 ** ./middleware/apiErrorInterceptor.js
 **/